import { ecorEnv } from '@/../environments/environment';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable, inject, signal, computed } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface ParadataEvent {
    paradataEventTypeId: ParadataEventEnum
    surveyId: number;
    eventDtm: Date;
}

export const ParadataEventParam = 'paradataEventJson';

export enum ParadataEventEnum {
    NumberofSSRssubmittedbySurvey = 1,
    ReportNow = 2,
    ExportCSV = 3,
    ExportExcel = 4,
    UsedAuthenticationCode = 5,
    InvalidAuthenticationCode = 6,
    ExpiredAuthenticationCode = 7,
    NumberofSSRssubmittedwithattachment = 8,
    RemoveDelegates = 9,
    ResentRequest = 10,
    NumberofCaseswithcomments = 11,
    Caseswithattachmentsfromcomments = 12,
    FilingStatus = 13,
    HowDoI = 14,
    CancelMessage = 15,
    SubmitMessage = 16,
    ActiveTabClick = 17,
    SurveyDashboardHistoryTab = 18,
    MessageStatusResolved = 19,
    MessageStatusActive = 20,
    RequesttoOpen = 21,
    AddAuthenticationCode = 22,
    CancelAuthenticationCodeRequest = 23,
    BeginbuttonforAuthenticationCode = 24,
    GridView = 25,
    ListView = 26,
    ManageAccount = 27,
    SignOut = 28,
    CensusBreadcrumbs = 29,
    Options = 30,
    Information = 31,
    MoreInformation = 32,
    FAQs = 33,
    Message = 34,
    ShareSurveyAccess = 35,
    TimeExtension = 36,
    ShareSurveySubmitSuccess = 37,
    ShareSurveySubmitFail = 38,
    CurrentDelegates = 39,
    Enterednotestodelegate = 40,
    COSInformationClick = 41,
    ASMInformation = 42,
    CancelShareSurveyAccessRequest1 = 43,
    CancelShareSurveyAccessRequest2 = 44,
    PostbuttontoReopen = 45,
    ASMFAQs = 46,
    COSFAQs = 47,
    ConfirmShareSurveyAccess = 48,
    Watchvideoforthename = 49,
    Canister = 50,
    UnauthorizedCode=51
}

@Injectable({
    providedIn: 'root'
})
export class ParadataEventService {
    private httpClient = inject(HttpClient);
    
    // Signal-based state management
    private _url = signal<string>(ecorEnv.apiEndpoint + '/secure/sessions');
    private _events = signal<ParadataEvent[]>([]);
    
    // Computed properties
    url = computed(() => this._url());
    events = computed(() => this._events());
    hasEvents = computed(() => this._events().length > 0);

    add(paradataEventEnum: ParadataEventEnum, surveyId: number = null): void {
        const currentEvents = this._events();
        const newEvent: ParadataEvent = {
            paradataEventTypeId: paradataEventEnum,
            surveyId: surveyId,
            eventDtm: new Date()
        };
        this._events.set([...currentEvents, newEvent]);
    }

    getAndClear(): string {
        const currentEvents = this._events();
        if (currentEvents.length === 0) {
            return null;
        }

        const ret = JSON.stringify(currentEvents);
        this._events.set([]);
        return ret;
    }

    flushParadataevents(): void {
        if (this.hasEvents()) {
            const params = new HttpParams()
                .set(ParadataEventParam, this.getAndClear());

            this.httpClient.post<any>(this.url(), params)
                .pipe(
                    catchError(this.handleError)
                )
                .subscribe();
        }
    }
    
    private handleError = (error: HttpErrorResponse) => {
        console.error('ParadataEventService error:', error);
        return throwError(() => new Error(`ParadataEventService error: ${error.message}`));
    };
}
